import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { AddTemporaryDialog, RemoveTemparyCustomersDialog, AddInvalidDialog, NoMemberContactDialog, SendSmsDialog, DeleteNonMemberDialog } from "@icoach/nonMember/dialog/";
import { Icons, IconButton } from "@curves/ui-base";
import { findIndexFn } from "@util/utils";
import { CUSTOMER_TYPE } from "@constants/";
import { NON_MEMBER_ROUTER } from "@icoach/router/routerPath";

export const DefaultIconMap = {
	invalid: {
		description: "將顧客或名單人員設定為無效",
		Icon: <Icons.UserSlash />,
		Dialog: AddInvalidDialog,
	},
	remove: {
		description: "刪除顧客或名單人員",
		Icon: <Icons.Trash />,
		Dialog: DeleteNonMemberDialog,
	},
	removetemp: {
		description: "刪除暫存清單內的顧客或名單人員",
		Icon: <Icons.Trash />,
		Dialog: RemoveTemparyCustomersDialog,
	},
	sms: { Icon: <Icons.PaperPlane />, Dialog: SendSmsDialog },
	folder: { Icon: <Icons.FolderPlus />, Dialog: AddTemporaryDialog },
	contact: { Icon: <Icons.Phone />, Dialog: NoMemberContactDialog },
	appointment: { Icon: <Icons.Assignment />, Dialog: null, to: ({ urls }) => `${urls["apo"]}` },
	review: { Icon: <Icons.RemoveRedEye />, Dialog: null },
};

/**
 * filterKey 顧客/名單  -> customerID, 暫存名單 -> temporaryID
 */

const IconGroupHeader = props => {
	const {
		selectedRef: domRef,
		rowsData = [],
		viewIconArray = [],
		dialogProps = {},
		IconMap = DefaultIconMap,
		filterKey = "customerID",
		urls,
		refresh: refreshProp,
		clearAllChecked,
		...others
	} = props;
	const history = useHistory();
	const [dialogOpen, setDialogOpen] = useState(null);
	const [sourceData, setSourceData] = useState(null);

	const checkedAction = (targetArray, targetData) =>
		targetArray.reduce((acc, cur) => {
			const _index = findIndexFn(targetData, filterKey, cur.value);
			let newAcc = [...acc];
			if (cur.checked && _index !== -1) newAcc.push(targetData[_index]);
			return newAcc;
		}, []);

	const handleClose = () => {
		setDialogOpen(null);
		setSourceData(null);
	};

	const handleRefresh = () => {
		if (dialogOpen === "folder") {
			clearAllChecked();
		} else if (["contact", "invalid"].includes(dialogOpen)) {
			window.location.reload();
		} else if (dialogOpen === "remove") {
			const r = sourceData.customerType === CUSTOMER_TYPE.CUSTOMER ? NON_MEMBER_ROUTER.CUSTOMER.OVERVIEW : NON_MEMBER_ROUTER.PROSPECT.OVERVIEW;
			history.push(r);
		} else {
			refreshProp();
		}
	};

	const handleDialogMessage = (target, hasDialog) => {
		if (hasDialog) {
			const selectedItem = domRef && domRef.current ? checkedAction(domRef.current, rowsData) : rowsData;
			if (selectedItem.length === 0) return;
			if (target === "contact") {
				const params = { peopleID: selectedItem[0].customerID };
				setSourceData(params);
			} else if (target === "invalid") {
				const { customerID, displayTypeText, typeText } = selectedItem[0];
				const params = { list: [customerID], typeText: displayTypeText || typeText || "" };
				setSourceData(params);
			} else if (target === "remove") {
				const { customerType, customerID, customerName, cellPhone, displayTypeText, typeText } = selectedItem[0];
				const params = { list: [customerID], customerType: customerType, typeText: displayTypeText || typeText || "", info: [{ name: customerName, cellPhone: cellPhone }] };
				setSourceData(params);
			} else {
				setSourceData([...selectedItem]);
			}
			setDialogOpen(target);
		} else if (target === "appointment" && urls["apo"]) {
			history.push(urls["apo"]);
		}
	};

	return (
		<React.Fragment>
			{viewIconArray.map(target => {
				const { Icon, Dialog } = IconMap[target] || {};
				return IconMap[target] ? (
					<React.Fragment key={target}>
						<IconButton onClick={() => handleDialogMessage(target, !!Dialog)}>{Icon}</IconButton>
						{Dialog && (
							<Dialog
								{...others}
								open={dialogOpen === target}
								onClose={handleClose}
								sourceData={dialogOpen === target ? sourceData : []}
								refresh={handleRefresh}
								{...(dialogProps[target] || {})}
							/>
						)}
					</React.Fragment>
				) : null;
			})}
		</React.Fragment>
	);
};

export default IconGroupHeader;
